{
  "US": 10,
  "EU": 9,
  "GB": 8,
  "JP": 7,
  "CN": 6,
  "IN": 5,
  "DE": 4,
  "FR": 4,
  "CA": 3,
  "AU": 3,
  "CH": 3,
  "SN": 2,
  "CM": 2,
  "NG": 2,
  "ZA": 2,
  "BR": 2,
  "RU": 2,
  "MX": 2,
  "KR": 2,
  "ID": 2,
  "TH": 2,
  "MY": 2,
  "PH": 2,
  "SG": 2,
  "HK": 2,
  "TW": 2,
  "SA": 2,
  "AE": 2,
  "EG": 2,
  "KE": 2,
  "GH": 2,
  "UG": 2,
  "TZ": 2,
  "RW": 2,
  "BD": 2,
  "PK": 2,
  "LK": 2,
  "MM": 2,
  "NP": 2,
  "CL": 2,
  "CO": 2,
  "PE": 2,
  "AR": 2,
  "VE": 2,
  "UY": 2,
  "PY": 2,
  "BO": 2,
  "EC": 2,
  "GT": 2,
  "SV": 2,
  "HN": 2,
  "NI": 2,
  "CR": 2,
  "PA": 2,
  "JM": 2,
  "TT": 2,
  "BB": 2,
  "BS": 2,
  "BZ": 2,
  "GD": 2,
  "LC": 2,
  "VC": 2,
  "DM": 2,
  "AG": 2,
  "KN": 2,
  "TR": 2,
  "PL": 2,
  "CZ": 2,
  "HU": 2,
  "RO": 2,
  "BG": 2,
  "HR": 2,
  "SI": 2,
  "SK": 2,
  "EE": 2,
  "LV": 2,
  "LT": 2,
  "FI": 2,
  "DK": 2,
  "NO": 2,
  "SE": 2,
  "IS": 2,
  "PT": 2,
  "IE": 2,
  "NL": 2,
  "BE": 2,
  "AT": 2,
  "LU": 2,
  "IT": 2,
  "ES": 2,
  "GR": 2,
  "CY": 2,
  "MT": 2,
  "SI": 2,
  "AL": 2,
  "MK": 2,
  "RS": 2,
  "BA": 2,
  "HR": 2,
  "ME": 2,
  "XK": 2
}